export default class OpenFormArg
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.OpenFormArg";
	menuItemId = null;
	callerKey = null;
	
	paramString = null;
	paramObject = null;
	
	enterMainForm = false;
	mainFormWhereValues = null;
	
	//优先级高
	addFixedGroupRelation = false;
	linkGroupAlias = null;
	//优先级低
	addAutoGroupRelation = false;
	isPopUp = false;
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/OpenFormArg.js